<div class="smart_replies">
  <div class="replies_scroll">
    <span class="intro">{{ 'settings.smart_replies_intro' | translate }}</span>

    <div class="lock_note" *ngIf="!hasAccounts">
      <ui-svg-icon svgIcon="lock" size="small"></ui-svg-icon>
      <span>{{ 'settings.smart_replies_locked' | translate }}</span>
    </div>

    <div class="replies_form" [class.locked]="!hasAccounts">
      <!-- Pricing sourcing -->
      <section class="section">
        <div class="section_head">
          <span class="section_title">{{ 'settings.smart_replies_pricing_title' | translate }}</span>
          <span class="section_desc">{{ 'settings.smart_replies_pricing_desc' | translate }}</span>
        </div>
        <div class="opt_list">
          <div
            *ngFor="let opt of pricingOptions"
            class="opt"
            [class.selected]="settings.pricing_source === opt.value"
            (click)="selectPricing(opt.value)">
            <span class="rd"></span>
            <span class="opt_text">
              <span class="opt_label">
                {{ opt.labelKey | translate }}
                <span class="opt_default" *ngIf="opt.isDefault">{{ 'settings.smart_replies_default' | translate }}</span>
              </span>
              <span class="opt_desc">{{ opt.descKey | translate }}</span>
            </span>
          </div>
        </div>
      </section>

      <!-- Product representation -->
      <section class="section">
        <div class="section_head">
          <span class="section_title">{{ 'settings.smart_replies_product_representation' | translate }}</span>
          <span class="section_desc">{{ 'settings.smart_replies_product_representation_hint' | translate }}</span>
        </div>
        <div class="tone_grid">
          <div class="field">
            <div class="segmented">
              <button type="button" [class.on]="settings.product_format === 'bullets'" (click)="setProductFormat('bullets')">
                {{ 'settings.smart_replies_format_bullets' | translate }}
              </button>
              <button type="button" [class.on]="settings.product_format === 'table'" (click)="setProductFormat('table')">
                {{ 'settings.smart_replies_format_table' | translate }}
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- Live sample-reply preview -->
      <div class="preview">
        <div class="preview_head">
          <ui-svg-icon svgIcon="sparkle" size="small"></ui-svg-icon>
          <span class="preview_head_title">{{ 'settings.smart_replies_preview_title' | translate }}</span>
          <span class="preview_head_note">{{ 'settings.smart_replies_preview_note' | translate }}</span>
        </div>
        <div class="preview_body">
          <p class="pv_greeting">{{ 'settings.smart_replies_preview_greeting_default' | translate }}</p>
          <p>{{ 'settings.smart_replies_preview_intro' | translate }}</p>

          <ul *ngIf="settings.product_format === 'bullets'">
            <li>
              {{ 'settings.smart_replies_preview_product_1' | translate }}
              <ng-container *ngTemplateOutlet="priceTpl; context: { amount: '€18.50' }"></ng-container>
            </li>
            <li>
              {{ 'settings.smart_replies_preview_product_2' | translate }}
              <ng-container *ngTemplateOutlet="priceTpl; context: { amount: '€22.00' }"></ng-container>
            </li>
          </ul>

          <table class="pv_table" *ngIf="settings.product_format === 'table'">
            <thead>
              <tr>
                <th>{{ 'settings.smart_replies_preview_col_product' | translate }}</th>
                <th>{{ 'settings.smart_replies_preview_col_price' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ 'settings.smart_replies_preview_product_1_short' | translate }}</td>
                <td><ng-container *ngTemplateOutlet="cellTpl; context: { amount: '€18.50' }"></ng-container></td>
              </tr>
              <tr>
                <td>{{ 'settings.smart_replies_preview_product_2_short' | translate }}</td>
                <td><ng-container *ngTemplateOutlet="cellTpl; context: { amount: '€22.00' }"></ng-container></td>
              </tr>
            </tbody>
          </table>

          <p class="pv_sign">{{ 'settings.smart_replies_preview_sign' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Save bar -->
  <div class="save_bar" *ngIf="dirty">
    <span class="sb_dot"></span>
    <span class="sb_text">{{ 'settings.smart_replies_unsaved' | translate }}</span>
    <div class="sb_actions">
      <ui-button
        type="secondary"
        [label]="'settings.smart_replies_discard' | translate | uppercase"
        (click)="discard()">
      </ui-button>
      <ui-button
        type="primary"
        [label]="'settings.smart_replies_save' | translate | uppercase"
        icon="check-icon"
        iconPosition="start"
        (click)="save()">
      </ui-button>
    </div>
  </div>
</div>

<!-- Bullet price clause: "are €18.50 / case (suffix)" or "are [PRICE] / case" -->
<ng-template #priceTpl let-amount="amount">
  <ng-container *ngIf="settings.pricing_source === 'placeholder'; else realPrice">
    {{ 'settings.smart_replies_preview_are' | translate }}
    <span class="pv_token">[PRICE]</span>
    {{ 'settings.smart_replies_preview_unit' | translate }}
  </ng-container>
  <ng-template #realPrice>
    {{ 'settings.smart_replies_preview_are' | translate }}
    <b>{{ amount }} {{ 'settings.smart_replies_preview_unit' | translate }}</b>
    <span class="pv_sign" *ngIf="pricingSuffixKey"> {{ pricingSuffixKey | translate }}</span>
  </ng-template>
</ng-template>

<!-- Table price cell: amount or [PRICE] token -->
<ng-template #cellTpl let-amount="amount">
  <span class="pv_token" *ngIf="settings.pricing_source === 'placeholder'; else cellReal">[PRICE]</span>
  <ng-template #cellReal>{{ amount }}</ng-template>
</ng-template>
